import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { Helmet } from "react-helmet";

export class GeneScape extends Component {
    static displayName = GeneScape.name;

    render() {
        return (
            <div>
                <div className="App">
                    <Helmet>
                        <title>RetNet: GeneScape</title>
                    </Helmet>
                </div>
                <NavMenu />

                <div className="genescape-frame">
                    <iframe
                        src="https://ffb.genescape.ai"
                        title="GeneScape"
                        className="genescape-iframe"
                        style={{ width: '100%', height: '55vh', border: 'none' }}
                        allow="fullscreen"
                    />
                </div>
            </div>
        );
    }
}
